/* =========================================================================
   MEN STARTER PACK — Journal behaviour
   Filters, checklist state, reading progress, sticky TOC.
   ========================================================================= */
(function () {
  "use strict";

  const STORE_KEY = "msp-list-v1";
  const reduceMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function readState() {
    try {
      return JSON.parse(localStorage.getItem(STORE_KEY) || "{}") || {};
    } catch (error) {
      return {};
    }
  }

  function writeState(state) {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify(state));
    } catch (error) {
      /* Storage can be full or disabled. The list still works for this page. */
    }
  }

  function initChecklist(root) {
    const scope = root || document;
    const boxes = scope.querySelectorAll("[data-jm-check]");
    if (!boxes.length) return;

    const state = readState();
    const update = () => {
      const all = Array.from(scope.querySelectorAll("[data-jm-check]"));
      const checked = all.filter((box) => box.checked).length;
      const percent = all.length ? Math.round((checked / all.length) * 100) : 0;

      scope.querySelectorAll("[data-jm-progress-fill]").forEach((fill) => {
        fill.style.width = percent + "%";
      });
      scope.querySelectorAll("[data-jm-progress-count]").forEach((label) => {
        label.textContent = checked + " / " + all.length;
      });
      scope.querySelectorAll("[data-jm-progress-bar]").forEach((bar) => {
        bar.setAttribute("aria-valuenow", String(checked));
        bar.setAttribute("aria-valuemax", String(all.length));
      });
    };

    boxes.forEach((box) => {
      const id = box.getAttribute("data-jm-check");
      if (!id) return;
      box.checked = Boolean(state[id]);
      box.addEventListener("change", () => {
        const next = readState();
        if (box.checked) next[id] = true;
        else delete next[id];
        writeState(next);
        update();
      });
    });

    scope.querySelectorAll("[data-jm-reset]").forEach((button) => {
      button.addEventListener("click", () => {
        writeState({});
        boxes.forEach((box) => {
          box.checked = false;
        });
        update();
      });
    });

    update();
  }

  function initFilters(root) {
    const scope = root || document;
    const buttons = scope.querySelectorAll("[data-jm-filter]");
    if (!buttons.length) return;

    const cards = scope.querySelectorAll("[data-jm-card]");
    const applyFilter = (button) => {
      const filter = button.getAttribute("data-jm-filter");
      buttons.forEach((item) => item.classList.toggle("is-active", item === button));
      cards.forEach((card) => {
        const match = filter === "all" || card.getAttribute("data-category") === filter;
        card.hidden = !match;
      });
      const count = scope.querySelector("[data-jm-filter-count]");
      if (count) {
        const visible = Array.from(cards).filter((card) => !card.hidden).length;
        count.textContent = visible + " files";
      }
    };

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        applyFilter(button);
        if (history.replaceState) {
          history.replaceState(null, "", "#" + button.getAttribute("data-jm-filter"));
        }
      });
    });

    const hash = decodeURIComponent(window.location.hash.slice(1)).toLowerCase();
    const applyHash = () => {
      const next = decodeURIComponent(window.location.hash.slice(1)).toLowerCase();
      const target = Array.from(buttons).find(
        (button) => button.getAttribute("data-jm-filter") === next
      );
      if (target) applyFilter(target);
    };
    if (hash) applyHash();
    window.addEventListener("hashchange", applyHash);
  }

  function initReadingProgress() {
    const bar = document.querySelector("[data-jm-progress]");
    if (!bar) return;
    const fill = bar.querySelector("span");
    if (!fill) return;

    let ticking = false;
    const update = () => {
      ticking = false;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const percent = max > 0 ? Math.min(100, Math.max(0, (window.scrollY / max) * 100)) : 0;
      fill.style.width = percent + "%";
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
  }

  function initToc() {
    const toc = document.querySelector("[data-jm-toc]");
    if (!toc || !("IntersectionObserver" in window)) return;

    const links = Array.from(toc.querySelectorAll('a[href^="#"]'));
    const headings = links
      .map((link) => document.getElementById(link.getAttribute("href").slice(1)))
      .filter(Boolean);
    if (!headings.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links.forEach((link) => {
            link.classList.toggle(
              "is-active",
              link.getAttribute("href") === "#" + entry.target.id
            );
          });
        });
      },
      { rootMargin: "-20% 0px -70% 0px" }
    );
    headings.forEach((heading) => observer.observe(heading));
  }

  function init() {
    initChecklist();
    initFilters();
    initReadingProgress();
    initToc();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initChecklist(event.target);
    initFilters(event.target);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
